import React from 'react'
import { object, func } from 'prop-types'
import { Warning } from '../../components/Messages'
import CountrySelectInput from '../../components/CountrySelectInput/CountrySelectInput'
import { withContext } from '../../../utils/withContext'
import { validateEmail, validatePostalCode } from '../../helpers/validations'

import styles from './UserDataPage.styl'

class UserDataPage extends React.Component {

	static propTypes = {
		athlete: object,
		handleSubmit: func,
		context: object
	}

	constructor(props) {
		super(props)
		this.state = { athlete: props.athlete }
		this.validate = this.validate.bind(this)
	}

	missingInfo() {
		const { context: { i18n } } = this.props
		const { athlete: { phone, address: { street, postalCode, city, country } } } = this.state

		const missingList = []
		if (!phone) {
			missingList.push(<li>{ i18n`missing_cellphone_number` }</li>)
		}
		if (!street || !city || !postalCode || !country) {
			missingList.push(<li>{ i18n`missing_address_number` }</li>)
		}
		if (missingList.length) {
			return (
				<div className={ styles['missing_information_container'] }>
					<strong>{ i18n`missing_information_label` }</strong>
					<ul>
						{ missingList }
					</ul>
				</div>)
		}
		return null
	}
	validate(e) {
		const { athlete } = this.state
		const { handleSubmit } = this.props
		e.preventDefault()
		if (athlete.email && !validateEmail(athlete.email)) {
			// window.alert("Introduz um email válido")
			return
		}
		// if (athlete.postalCode && validatePostalCode(athlete.postalCode)) {
		//     window.alert("Introduz um código postal válido (xxxx-xxx)")
		//
		//      return
		// }
		handleSubmit(e, athlete)
	}

	render() {
		const { athlete } = this.state
		const { context: { i18n } } = this.props
		return (
			<div className={ styles.dataBox }>
				<div className={ styles['content'] }>
					<form onSubmit={ this.validate.bind(this) }>
						<h2 className={ styles.title }>{ i18n`account_info_label` }</h2>
						{ this.missingInfo() }
						<div className={ styles.dadosContainer }>
							<label>{ i18n`name_label` }</label>
							<input type="text" value={ athlete.name ? athlete.name : '' } placeholder="Nome" onChange={ (e) => { this.setState({ athlete: { ...athlete, name: e.target.value } }) } } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`email_label` }</label>
							<input type="text" value={ athlete.email ? athlete.email : '' } placeholder="Email" onChange={ (e) => { this.setState({ athlete: { ...athlete, email: e.target.value } }) } } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_phone_label` }</label>
							<input type="text" value={ athlete.phone ? athlete.phone : '' } placeholder="Telefone" onChange={ (e) => { this.setState({ athlete: { ...athlete, phone: e.target.value } }) } } />
						</div>
						<h2 className={ `${ styles.title } ${ styles.second }` }>{ i18n`registry_address_label` }</h2>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_address_label` }</label>
							<input type="text" value={ athlete.address && athlete.address.street ? athlete.address.street : '' } placeholder="Morada" onChange={ (e) => { this.setState({ athlete: { ...athlete, address: { ...athlete.address, street: e.target.value } } }) } } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_postal_code_label` }</label>
							<input type="text" value={ athlete.address && athlete.address.postalCode ? athlete.address.postalCode : '' } placeholder="Código Postal" onChange={ (e) => { this.setState({ athlete: { ...athlete, address: { ...athlete.address, postalCode: e.target.value } } }) } } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_city_label` }</label>
							<input type="text" value={ athlete.address && athlete.address.city ? athlete.address.city : '' } placeholder="Cidade" onChange={ (e) => { this.setState({ athlete: { ...athlete, address: { ...athlete.address, city: e.target.value } } }) } } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_country_label` }</label>
							<CountrySelectInput
								className={ styles['country-select-input'] }
								onChange={ (e) => { this.setState({ athlete: { ...athlete, bilingAddress: { ...athlete.bilingAddress, country: e.target.value } } }) } }
								value={ athlete.bilingAddress && athlete.bilingAddress.country ? athlete.bilingAddress.country : '' }
							/>
						</div>
						<div className={ styles.submitButton } >
							<input type="submit" value={ i18n`save_label` } />
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withContext(UserDataPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserDataPage/UserDataPage.js